var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBanner && _vm.hasWhatsappV3Channel && !_vm.isExpired
    ? _c(
        "div",
        { staticClass: "whatsapp-v3-warning-wrapper" },
        [
          _c("transition", { attrs: { name: "slide-down" } }, [
            _vm.bannerVisible
              ? _c("div", { staticClass: "whatsapp-v3-warning-banner" }, [
                  _c("div", { staticClass: "banner-main" }, [
                    _c(
                      "div",
                      {
                        staticClass: "banner-content",
                        on: {
                          click: function ($event) {
                            _vm.showDetailModal = true
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "material-icons warning-icon" },
                          [_vm._v("warning")]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "banner-text" }, [
                          _vm._v(
                            "\n                        ⚠️ WhatsApp V3 servisi şu an stabil değil. Detaylar için tıklayın.\n                    "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close-btn",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.closeBanner.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("close"),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "progress-bar-container" }, [
                    _c("div", {
                      staticClass: "progress-bar",
                      style: { width: _vm.progressWidth + "%" },
                    }),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              staticClass: "whatsapp-v3-detail-modal",
              attrs: {
                visible: _vm.showDetailModal,
                footer: null,
                closable: true,
                width: "600px",
                centered: "",
              },
              on: { cancel: _vm.closeDetailModal },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "modal-title" }, [
                          _c(
                            "span",
                            {
                              staticClass: "material-icons",
                              staticStyle: {
                                color: "#f5a623",
                                "margin-right": "8px",
                              },
                            },
                            [_vm._v("warning")]
                          ),
                          _vm._v(
                            "\n                WhatsApp V3 Servis Bildirimi\n            "
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                2611291447
              ),
            },
            [
              _vm._v(" "),
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "warning-section" }, [
                  _c("div", { staticClass: "section-header" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("error_outline"),
                    ]),
                    _vm._v(" "),
                    _c("h3", [_vm._v("Servis Durumu")]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("\n                    WhatsApp V3 servisi şu an "),
                    _c("strong", [_vm._v("stabil değil")]),
                    _vm._v(
                      ". Gün içinde bağlantınız kopabilir\n                    ve "
                    ),
                    _c("strong", [_vm._v("tekrar QR kod okutmanız")]),
                    _vm._v(" gerekebilir.\n                "),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                    Kanal ayarlarından hattınızın bağlantı durumunu kontrol edip, gerekirse tekrar QR kod okutabilirsiniz.\n                "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-section" }, [
                  _c("div", { staticClass: "section-header" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("info"),
                    ]),
                    _vm._v(" "),
                    _c("h3", [_vm._v("WhatsApp ID Güncellemesi")]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                    WhatsApp'ın son güncellemesi olan "
                    ),
                    _c("strong", [_vm._v("WhatsApp ID")]),
                    _vm._v(
                      " özelliği (kullanıcıların telefon\n                    numaralarını gizleme özelliği) yayına alındı.\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "highlight-text" }, [
                    _vm._v(
                      "\n                    ⚠️ Yeni sistemde numarasını gizleyen kullanıcıların telefon numaralarına erişemeyeceksiniz.\n                "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "action-section" },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.goToChannelSettings },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "material-icons",
                            staticStyle: {
                              "font-size": "18px",
                              "margin-right": "4px",
                            },
                          },
                          [_vm._v("settings")]
                        ),
                        _vm._v(
                          "\n                    Kanal Ayarlarına Git\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("a-button", { on: { click: _vm.closeDetailModal } }, [
                      _vm._v("\n                    Anladım\n                "),
                    ]),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }